/**
 * list of country codes supported
 */
export enum CountryCode {
  UnitedStates = 'US',
  PuertoRico = 'PR',
}
